import './navbarBottom.scss'
import clsx from 'clsx'
import {
    HelpIcon,
    LeftArrowIcon,
    RightArrowIcon,
    Contact1Icon,
} from '@/shared/assets'

export const NavbarBottom = ({
    isOpen,
    toggleSidebar,
}: {
    isOpen: boolean
    toggleSidebar: () => void
}) => {
    return (
        <div className="navbar-bottom">
            <div>
                <a
                    className={clsx('navbar-bottom__contact-link', {
                        closed: !isOpen,
                    })}
                    href="https://t.me/+98PKttBwkDsyM2Ri"
                    rel="noreferrer noopener"
                    target="_blank"
                >
                    <img className="telegram-logo" src={Contact1Icon} />
                    <p className={clsx({ closed: !isOpen })}>Канал сервиса</p>
                </a>
            </div>

            <a
                className={clsx('navbar-bottom__support-link', {
                    closed: !isOpen,
                })}
                href="https://t.me/yuriygoy"
                rel="noreferrer noopener"
                target="_blank"
            >
                <img className="icon" src={HelpIcon} />
                <p className={clsx({ closed: !isOpen })}>Поддержка</p>
            </a>

            {/* <NavbarItem */}
            {/*     to="/settings/account" */}
            {/*     icon={HelpIcon} */}
            {/*     text="Поддержка" */}
            {/*     isOpen={isOpen} */}
            {/* /> */}
            <button
                className={clsx('navbar-bottom__toggle-button', {
                    closed: !isOpen,
                })}
                onClick={toggleSidebar}
            >
                <img
                    src={isOpen ? LeftArrowIcon : RightArrowIcon}
                    className="icon"
                />
                <p className={clsx({ closed: !isOpen })}>Свернуть меню</p>
            </button>
        </div>
    )
}
